/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from "react";
import { Col, Row } from "components/Grid";
import { Field, Form, Formik } from "formik";
import { InputField, SelectField } from "@fitinsur/components";
import {
  MobileLabel,
  FilterSearchContainer,
  RowFilter,
  FilterColumn,
  ColIcon,
  DialogCancel,
  DialogConfirm
} from "./styles";
import Colors from "../../constants/Colors";

import { LoaderContext } from '@fitinsur/contexts';
import { Button } from "../../components";
import Icon from "components/Icon";
import { useGetCustomFilterList, useSaveCustomFilters, useUpdateCustomFilters, useDeleteCustomFilters } from "@fitinsur/services/PersonService";
import { MessageCenter } from "utils";
import DialogComponent from "@fitinsur/components/Dialog";


const SaveFilters = ({ filterData, onFilterChange, onHandleFilter, setShowFilter, idDomain, idDomainApplication, onCleanFilter, children }) => {
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const mc = new MessageCenter();
  const formikRef = useRef(null);
  const [filterOptions, setFilterOptions] = useState([]);
  const [filterNameSelected, setFilterNameSelected] = useState({
    filterName: ""
  });
  const [isAbleToEdit, setIsAbleToEdit] = useState(false);
  const [isAbleToDelete, setIsAbleToDelete] = useState(false);
  const [isAbleToCreate, setIsAbleToCreate] = useState(false);
  const [currentFilter, setCurrentFilter] = useState({});
  const [typeDialog, setTypeDialog] = useState(null);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });

  const getFiltersListAndOptions = (response, method = "", dispatchEvent = true) => {
    const filterList = response.data.ret_value?.filter(
      (element) =>
        element.idDomain === idDomain && element.idDomainApplication === idDomainApplication
    ) || [];
    const option = [];
    filterList.map((element, index) => {
      // element.id = index;
      let opt = {
        label: element.filterName,
        value: element,
      };
      option.push(opt);
    });
    const optionSelected = option[method == "create" ? option.length - 1 : method == "update" ? currentFilter?.id : 0];
        if (optionSelected) handleChangeFilters(optionSelected?.value, dispatchEvent)
    setFilterOptions(option);
  }

  const handleChangeFilters = (filter, dispatchEvent = true) => {
    if (!filter) {
      filter = filterOptions[0].value
    }

    if (!dispatchEvent) {
      setFilterNameSelected({ filterName: filter.filterName });
      formikRef?.current && formikRef.current.setFieldValue("filtersList", filter)
      return
    }

    const filterDataArgs = [];
    for (const f of filterData) {
      f.value = filter.filterArgs[f.key];
      filterDataArgs.push(f);
    }
    setFilterNameSelected({ filterName: filter.filterName })
    setCurrentFilter(filter)
    if (dispatchEvent) onFilterChange(filterDataArgs, filter.filterName);
    formikRef?.current && formikRef.current.setFieldValue("filtersList", filter)
  }

  const handleSaveFilter = () => {
    if (!filterNameSelected.filterName.trim()) {
      return mc.error("Por favor, nome do filtro precisa ser informado.");
    }

    if (filterNameSelected.filterName.trim().toLocaleUpperCase() == 'DEFAULT') {
      return mc.error("Ocorreu um erro, nome do filtro não é válido.");
    }
    setIsAbleToCreate(false);
    setIsAbleToEdit(false);

    useSaveCustomFiltersRequest({
      filterName: filterNameSelected.filterName,
      idDomain: idDomain,
      idDomainApplication: idDomainApplication,
      filterArgs: {
        ...filterData
          .filter(v => v.value)
          .reduce((a, b) => {
            a[b.key] = b.value;
            return a
          }, {})
      }
    }).then(res => {
      if (res.data.ret_code === 200) {
        mc.success('Filtro criado com sucesso');
        useGetCustomFilterRequest().then(res => getFiltersListAndOptions(res, 'create'))
      }
    })
  }

  const handleUpdateFilter = () => {
    if (!filterNameSelected.filterName.trim()) {
      return mc.error("Por favor, o nome do filtro precisa ser informado.");
    }
    if (filterNameSelected.filterName.trim().toLocaleUpperCase() == 'DEFAULT') {
      return mc.error("Ocorreu um erro, nome do filtro não é válido.");
    }

    setIsAbleToCreate(false);
    setIsAbleToEdit(false);

    useUpdateCustomFiltersRequest({
      filterName: filterNameSelected.filterName,
      idDomain: idDomain,
      id: currentFilter?.id,
      idDomainApplication: idDomainApplication,
      filterArgs: {
        ...filterData
          .filter(v => v.value)
          .reduce((a, b) => {
            a[b.key] = b.value;
            return a
          }, {})
      }
    }).then(res => {
      if (res.data.ret_code === 200) {
        mc.success('Filtro alterado com sucesso');
        useGetCustomFilterRequest().then(res => getFiltersListAndOptions(res, "update"))
      }
    })
  }

  const handleDeleteFilter = () => {
        if (filterNameSelected.filterName.toLocaleUpperCase() == 'DEFAULT') {
      return mc.error("Este filtro não pode ser removido!");
    }
    setIsAbleToDelete(false);

    useDeleteCustomFiltersRequest({
      filterName: filterNameSelected.filterName,
      idDomain: idDomain,
      id: currentFilter?.id,
      idDomainApplication: idDomainApplication,
    }).then(res => {
      if (res.data.ret_code === 200) {
        mc.success('Filtro removido com sucesso');
        useGetCustomFilterRequest().then(res => {
          getFiltersListAndOptions(res);
          onCleanFilter();
        })
      }
    })
  }

  const handleConfirmationDelete = () => {
    if (filterNameSelected.filterName) {
      setTypeDialog('deleteFilter');
      setDialog({
        visible: true,
        title: 'REMOVER FILTRO',
        icon: 'exclamation',
        args: null
      })
    }
  }

  const {
    loading: useGetCustomFilterLoading,
    request: useGetCustomFilterRequest,
  } = useGetCustomFilterList(idDomain, idDomainApplication);

  const {
    loading: useSaveCustomFiltersLoading,
    request: useSaveCustomFiltersRequest,
  } = useSaveCustomFilters();

  const {
    loading: useUpdateCustomFiltersLoading,
    request: useUpdateCustomFiltersRequest,
  } = useUpdateCustomFilters();

  const {
    loading: useDeleteCustomFiltersLoading,
    request: useDeleteCustomFiltersRequest,
  } = useDeleteCustomFilters();

  useEffect(() => {
    updateIsLoadingStatus(useSaveCustomFiltersLoading || useUpdateCustomFiltersLoading || useDeleteCustomFiltersLoading);
  }, [useSaveCustomFiltersLoading, useUpdateCustomFiltersLoading, useDeleteCustomFiltersLoading]);

  useEffect(() => {
    useGetCustomFilterRequest().then((res) => {
      getFiltersListAndOptions(res, undefined, false);
    });
  }, []);

  return (
    <Formik
      onSubmit={(values) => { }}
      initialValues={{}}
      enableReinitialization={true}
      innerRef={formikRef}
    >
      {({ setFieldValue }) => {
        return (
          <Form>
            <FilterSearchContainer>
              <Row style={{ alignItems: "center" }}>
                <Col>
                  <MobileLabel>
                    FILTRO
                  </MobileLabel>
                </Col>
                <Col style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Row>
                    <ColIcon>
                      <Icon
                        title="Editar Filtro"
                        name="edit"
                        onClick={(e) => {
                          setFilterNameSelected({ filterName: currentFilter?.filterName });
                          formikRef?.current.setFieldValue("nmFilter", currentFilter?.filterName);
                          setIsAbleToEdit(true);
                          setIsAbleToCreate(false);
                          setIsAbleToDelete(false);
                        }}
                        disabled={filterNameSelected.filterName == "DEFAULT" || !filterNameSelected.filterName || isAbleToCreate || isAbleToEdit}
                      />
                    </ColIcon>
                    <ColIcon style={{ paddingBottom: "10px" }}>
                      <Icon
                        title="Limpar Filtros"
                        name="trash"
                        disabled={filterNameSelected.filterName == "DEFAULT" || !filterNameSelected.filterName || isAbleToCreate || isAbleToEdit}
                        onClick={() => {
                          setIsAbleToDelete(true);
                          setIsAbleToCreate(false);
                          setIsAbleToEdit(false);
                          handleConfirmationDelete();
                        }}
                      />
                    </ColIcon>
                    <ColIcon>
                      <Icon
                        title="Adicionar Filtro"
                        name="add-grey"
                        disabled={isAbleToCreate || isAbleToEdit}
                        onClick={() => {
                          setFilterNameSelected({ filterName: "" });
                          formikRef?.current.setFieldValue("nmFilter", "");
                          onCleanFilter()
                          setIsAbleToCreate(true);
                          setIsAbleToDelete(false);
                          setIsAbleToEdit(false);
                        }}
                      />
                    </ColIcon>
                  </Row>
                </Col>
              </Row>

              <RowFilter>
                {isAbleToEdit || isAbleToCreate ? (
                  <FilterColumn>
                    <Field
                      type="text"
                      validation={false}
                      name="nmFilter"
                      placeholder="Nome do filtro"
                      component={InputField}
                      onChange={(e) => {
                        setFilterNameSelected({ filterName: e });
                      }}
                    />
                  </FilterColumn>
                ) : (
                  <FilterColumn>
                    <Field
                      name="filtersList"
                      label="Meus filtros"
                      isRequired
                      value={filterNameSelected?.filterName}
                      options={filterOptions}
                      onChange={(filter) => {
                        handleChangeFilters(filter)
                      }}
                      component={SelectField}
                    />
                  </FilterColumn>
                )}
              </RowFilter>
              {children}
            </FilterSearchContainer>

            <Row align="center" className="apply-button-container">
              <Col>
                <Button
                  primary
                  type="button"
                  id="btnFilter"
                  style={{ textAlign: "center", width: "100%", marginBottom: `${isAbleToCreate || isAbleToEdit ? "25px" : "50px"}` }}
                  onClick={(e) => {
                    isAbleToCreate ? handleSaveFilter() : isAbleToEdit ? handleUpdateFilter() : setShowFilter(false), onHandleFilter()
                  }}
                >
                  {isAbleToEdit || isAbleToCreate ? "Salvar" : "Aplicar"}
                </Button>

                {isAbleToCreate || isAbleToEdit ?
                  <Button
                    third
                    type="button"
                    id="btnFilter"
                    style={{ textAlign: "center", width: "100%", marginBottom: "50px" }}
                    onClick={(e) => {
                      setIsAbleToCreate(false);
                      setIsAbleToEdit(false);
                      setFilterNameSelected({ filterName: currentFilter?.filterName })
                      formikRef?.current.setFieldValue("nmFilter", currentFilter?.filterName);
                      handleChangeFilters(currentFilter);
                    }}
                  >
                    Cancelar
                  </Button>
                  : null}
              </Col>
            </Row>

            <DialogComponent icon={dialog.icon} title={dialog.title} size='6x' show={dialog.visible}>
              {typeDialog === 'deleteFilter' &&
                <>
                  <DialogCancel onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setDialog({ visible: false, title: null, icon: null, args: null })
                  }}>
                    Cancelar
                  </DialogCancel>
                  <DialogConfirm onClick={(e) => {
                    handleDeleteFilter();
                    setDialog({ visible: false, title: null, icon: null, args: null })
                  }}>
                    Confirmar
                  </DialogConfirm>
                </>
              }
            </DialogComponent>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SaveFilters;
